// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reply-message[data-v-5db837da] {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  position: relative;
  background: var(--bg-color);
  padding: 10px;
  border-top: 1px solid var(--border-bottom-section);
  min-height: 60px;
}
.reply-message .quote[data-v-5db837da] {
  font-size: 0.6em;
}
.reply-message .color-line[data-v-5db837da] {
  height: auto;
  flex-basis: 3px;
  flex-shrink: 0;
  border-radius: 3px;
  margin-right: 10px;
  margin-left: 14px;
}
.reply-message .reply-block[data-v-5db837da] {
  display: flex;
  word-wrap: anywhere;
  overflow: hidden;
}
.reply-message .reply-block .icon-block[data-v-5db837da] {
  margin-right: 10px;
}
.reply-message .reply-block .reply-img[data-v-5db837da] {
  display: flex;
  margin-right: 10px;
}
.reply-message .reply-block .reply-img img[data-v-5db837da] {
  margin: auto;
  height: 35px;
  min-width: 5px;
  border-radius: 2px;
  max-width: 70px;
}
.reply-message .reply-block .reply-info[data-v-5db837da] {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.reply-message .reply-block .reply-info .reply-info-name[data-v-5db837da] {
  display: flex;
  flex: 1;
  align-items: center;
  font-size: 12px;
  font-weight: bold;
}
.reply-message .reply-block .reply-info .message-text[data-v-5db837da] {
  display: flex;
  flex: 1;
  align-items: center;
}
.reply-message .fa-times[data-v-5db837da] {
  position: absolute;
  right: 22px;
  top: 10px;
  cursor: pointer;
  font-weight: 200;
  color: var(--toolbtn-color);
  font-size: 16px;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/chat/ChatSelectedMsg.vue"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;EACb,kDAAkD;EAClD,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,OAAO;EACP,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,OAAO;EACP,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;AACjB","sourcesContent":[".reply-message[data-v-5db837da] {\n  width: 100%;\n  display: flex;\n  justify-content: flex-start;\n  position: relative;\n  background: var(--bg-color);\n  padding: 10px;\n  border-top: 1px solid var(--border-bottom-section);\n  min-height: 60px;\n}\n.reply-message .quote[data-v-5db837da] {\n  font-size: 0.6em;\n}\n.reply-message .color-line[data-v-5db837da] {\n  height: auto;\n  flex-basis: 3px;\n  flex-shrink: 0;\n  border-radius: 3px;\n  margin-right: 10px;\n  margin-left: 14px;\n}\n.reply-message .reply-block[data-v-5db837da] {\n  display: flex;\n  word-wrap: anywhere;\n  overflow: hidden;\n}\n.reply-message .reply-block .icon-block[data-v-5db837da] {\n  margin-right: 10px;\n}\n.reply-message .reply-block .reply-img[data-v-5db837da] {\n  display: flex;\n  margin-right: 10px;\n}\n.reply-message .reply-block .reply-img img[data-v-5db837da] {\n  margin: auto;\n  height: 35px;\n  min-width: 5px;\n  border-radius: 2px;\n  max-width: 70px;\n}\n.reply-message .reply-block .reply-info[data-v-5db837da] {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n.reply-message .reply-block .reply-info .reply-info-name[data-v-5db837da] {\n  display: flex;\n  flex: 1;\n  align-items: center;\n  font-size: 12px;\n  font-weight: bold;\n}\n.reply-message .reply-block .reply-info .message-text[data-v-5db837da] {\n  display: flex;\n  flex: 1;\n  align-items: center;\n}\n.reply-message .fa-times[data-v-5db837da] {\n  position: absolute;\n  right: 22px;\n  top: 10px;\n  cursor: pointer;\n  font-weight: 200;\n  color: var(--toolbtn-color);\n  font-size: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
